import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from "react";
import { navigate } from "gatsby";
import UserMenuItem from "../UserComponents/MenuItem";
import { appTheme } from "../../appTheme";
import { DrilldownMenu, ButtonBack, DrilldownMenuWrapper, SeparatorLine } from "../UserComponents/styled.elements";
import { DrilldownMenuItem } from "../UserComponents/styled.elements";
export var MenuItem = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(MenuItem, _React$PureComponent);

  function MenuItem(a) {
    var _this;

    _this = _React$PureComponent.call(this, a) || this, _this.handleChange = function () {
      var _this$props = _this.props,
          a = _this$props.item,
          b = _this$props.isAlwaysExpanded,
          c = _this$props.activeItem,
          d = a.items.map(function (_ref) {
        var a = _ref.link;
        return a;
      });
      0 < a.items.length && a.link && "drilldown" !== a.menuStyle && a.link !== location.pathname && d.find(function (a) {
        return a === location.pathname || a === location.pathname + "/";
      }) || (!_this.state.isExpanded && a.selectFirstItemOnExpand && a.items[0].link && navigate(a.items[0].link), ("drilldown" === a.menuStyle || !b) && (_this.setState({
        isExpanded: !_this.state.isExpanded
      }), "drilldown" === a.menuStyle && _this.setState({
        prevActiveItem: c
      })));
    }, _this.handleBack = function () {
      _this.setState({
        isExpanded: !_this.state.isExpanded
      }), _this.state.prevActiveItem && navigate(_this.state.prevActiveItem.link || "");
    }, _this.state = {
      isExpanded: a.item.hasActiveSubItem || "true" === a.item.expanded || "always" === a.item.expanded && "drilldown" !== a.item.menuStyle,
      prevActiveItem: a.firstSiblingItem
    };
    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(a) {
    (a.item.hasActiveSubItem !== this.props.item.hasActiveSubItem || this.props.item.expanded !== a.item.expanded) && this.setState({
      isExpanded: this.props.item.hasActiveSubItem || "true" === this.props.item.expanded || "always" === this.props.item.expanded && "drilldown" !== this.props.item.menuStyle
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        a = _this$props2.children,
        _this$props2$item = _this$props2.item,
        c = _this$props2$item.items,
        d = _this$props2$item.icon,
        e = _this$props2$item.label,
        f = _this$props2$item.sublabel,
        g = _this$props2$item.separatorLine,
        b = _this$props2.item,
        _this$state = this.state,
        h = _this$state.isExpanded,
        i = _this$state.prevActiveItem,
        j = c && 0 < c.length,
        k = "always" === this.props.item.expanded;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UserMenuItem, Object.assign({}, this.props, {
      isAlwaysExpanded: k,
      onClick: this.handleChange,
      isExpanded: h
    })), j && h && /*#__PURE__*/React.createElement(React.Fragment, null, "drilldown" === b.menuStyle ? /*#__PURE__*/React.createElement(DrilldownMenu, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DrilldownMenuWrapper, null, /*#__PURE__*/React.createElement(ButtonBack, {
      onClick: this.handleBack
    }, /*#__PURE__*/React.createElement("svg", {
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 12 10",
      width: "12px",
      height: "10px"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M2.414 5l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L2.414 5z",
      fill: appTheme.sidebar.caretColor
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2 5a1 1 0 011-1h8a1 1 0 110 2H3a1 1 0 01-1-1z",
      fill: appTheme.sidebar.caretColor
    })), (i === null || i === void 0 ? void 0 : i.label) || "Back"), /*#__PURE__*/React.createElement(DrilldownMenuItem, {
      icon: d,
      label: e,
      sublabel: f
    })), a)) : a), g && /*#__PURE__*/React.createElement(SeparatorLine, null));
  };

  return MenuItem;
}(React.PureComponent);